/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAPIAction } from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('app', [
  'getApps',
  'getApp',
  'updateApp',
  'deleteApp',
  'getTokens',
]);


function getApp(id) {
  return createAPIAction(
    types.getApp,
    {
      endpoint: `/lora/applications/${id}`,
    },
  )();
}

function updateApp(id, data) {
  return createAPIAction(
    types.updateApp,
    {
      endpoint: `/lora/applications/${id}`,
      body: data,
      method: 'PUT',
    },
  )();
}

function getApps(args) {
  return createAPIAction(
    types.getApps,
    {
      endpoint: '/lora/applications',
      query: args,
    },
  )();
}

function deleteApp(id) {
  return createAPIAction(
    types.deleteApp,
    {
      endpoint: `/lora/applications/${id}`,
      method: 'DELETE',
    },
  )();
}

function getTokens(id, args) {
  return createAPIAction(
    types.getTokens,
    {
      endpoint: '/tokens',
      query: {
        ...args,
        bind: id,
      },
    },
  )();
}

export default {
  getApps,
  getApp,
  updateApp,
  deleteApp,
  getTokens,
};




// WEBPACK FOOTER //
// ./src/redux/actions/app.js